var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form__label"},[_vm._t("default"),_c('span',{staticClass:"form__value"},[_vm._v(" "+_vm._s(_vm.title))]),(_vm.error)?_c('span',{staticClass:"form__error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }